import { articlesRoutes } from '@/modules';
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'default',
    component: () => import('@/views/DefaultView.vue'),
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/AboutView.vue'),
  },
  {
    path: '/contact',
    name: 'contact', // Coupled (TAG: F83ABD412A85474CAF953FB4C5C68CA9)
    component: () => import('@/views/ContactUsView.vue'),
  },
  {
    path: '/services',
    name: 'services',
    component: () => import('@/views/ServicesView.vue'),
  },
  {
    path: '/services/:id',
    name: 'servicedetails',
    component: () => import('@/views/ServiceDetailView.vue'),
    props: true,
  },
  {
    path: '/cis',
    component: () => import('@/views/CISView.vue'),
    name: 'cis',
  },
  {
    path: '/capability-statement',
    component: () => import('@/views/CapabilityStatementView.vue'),
    name: 'capability-statement',
  },
  {
    path: '/services/secureidentity-cryptography',
    redirect: { name: 'servicedetails', params: { id: 2 } },
  },
  {
    path: '/services/cloud-devops',
    redirect: { name: 'servicedetails', params: { id: 3 } },
  },
  {
    path: '/services/custom-dev',
    redirect: { name: 'servicedetails', params: { id: 1 } },
  },
  {
    path: '/services/full-stack',
    redirect: { name: 'servicedetails', params: { id: 4 } },
  },
  {
    path: '/services/certificate-estate-assessment',
    redirect: { name: 'servicedetails', params: { id: 7 } },
  },
  {
    path: '/services/private-pki-architecture-review',
    redirect: { name: 'servicedetails', params: { id: 8 } },
  },
  ...articlesRoutes,
];

routes.push({
  path: '/:pathMatch(.*)*',
  redirect: '/',
});

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
